export default `---
slug: italy
country: Italy
countryCode: ITA
continent: Europe
year: ongoing
title: "Italy — Home"
description: "Home. Desenzano del Garda, my hometown on Lake Garda, and a lifetime of memories across the Bel Paese."
thumbnail: /images/travels/ITA/italy_thumb.jpg
relatedLinks: []
---
![italy](/images/travels/ITA/italy_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Italy and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
